import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SpecialRequirementsTable from './SpecialRequirementsTable';
const Page = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsx(SpecialRequirementsTable, {}) }));
};
export default Page;
